import { useId } from '@react-aria/utils'
import Styles from 'screens/Campaign/Overview/EditChannelsModal/EditChannelsModal.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import RadioGroupStyles from 'screens/BrandPlan/ChangeStrategyModal/Schedule/RadioGroup.module.scss'
import { FormikCrosspostFrequencyRadioGroup } from 'screens/Campaign/Overview/EditChannelsModal/CrosspostFrequencyRadioGroup'

export const CrosspostFrequency = ({ name = 'crosspost_frequency' }: { name?: string }) => {
  const id = useId()

  return (
    <div className={Styles.daysToPost}>
      <Heading level={4} id={id}>
        Do you want to crosspost between channels?
      </Heading>
      <FormikCrosspostFrequencyRadioGroup name={name} aria-labelledby={id} className={RadioGroupStyles.radioGroup} />
    </div>
  )
}
